import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { DwOrmDataServiceToken, DwOrmDataService, DwMetaDataServiceToken, DwMetaDataService, DwConfigServiceToken, DwConfigService, DwSecurityUserService, DwCacheService, DwEventService, DwMediaRepositoryService, DwModalService } from "@devwareapps/devware-cap";
import { SchoolRepositoryService } from "../../schools/services/school-repository.service";
import { DateTimeUtilService } from "../../shared/util/date-time-util.service";
import { AcsWrittenResultEntity, AcsWrittenTestStatusAllItems, AppMetaData, StudentCourseForContextQueryEntity } from "../../../meta-data/app-meta-data.service";
import { Observable } from "rxjs";
import { map, mergeMap } from "rxjs/operators";


@Injectable({ providedIn: 'root' })
export class StudentRepositoryService {

    constructor(@Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        @Inject(DwConfigServiceToken) configService: DwConfigService,
        private dwSecurityUserService: DwSecurityUserService,
        private dwCacheService: DwCacheService,
        private dwEventService: DwEventService,
        private dateTimeUtilService: DateTimeUtilService,
        private dwMediaRepository: DwMediaRepositoryService,
        private router: Router,
        private schoolRepositoryService: SchoolRepositoryService,
        private dwModalService: DwModalService,
        private http: HttpClient,
    ) {

    }

    getAcsWrittenResults(studentCourseId: number): Observable<AcsWrittenResultEntity[]> {
        const query = AppMetaData.AcsWrittenResult.CreateQueryBuilder();

        query.query.FieldSettings.LoadAllLookupDisplayFields = true;
        query.addFilterAnd(f => f.Equal(a => a.StudentCourseId, studentCourseId));
        query.addFilterAnd(f => f.Equal(a => a.AcsWrittenTestStatusId, AcsWrittenTestStatusAllItems.Success));
        //query.addOrderByDesc(f => f.ExamDate);
        query.addOrderByDesc(f => f.ModifiedDateTime);

        return this.dwOrmDataService.executeQuery<AcsWrittenResultEntity>(query);
    }

    getStudentCourseForContext(studentCourseId: number): Observable<StudentCourseForContextQueryEntity> {

        return AppMetaData.Queries.StudentCourseForContext.CreateQueryBuilderWithMetaData(this.dwMetaDataService)
            .pipe(mergeMap(result => {

                const query = result.queryBuilder;

                query.addFilterAnd(f => f.Equal(a => a.StudentCourseId, studentCourseId));

                return this.dwOrmDataService.executeQuerySingle<StudentCourseForContextQueryEntity>(query);

            }));
    }
}